export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9640.f23add6a.jpg";